import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'
import Route from 'route-parser'
import { URL_DOC_DRAFTER_DOCUMENT_INTERVIEW } from 'constants/urls'
import { dismissPopover } from 'services/OverlayService'
import selectIsIE from 'redux/selectors/selectIsIE'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen, setUserRolesModalIsBasicMessage } from 'redux/actions'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import selectAolName from 'redux/selectors/selectAolName'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

const SsoRoute = new Route(URL_DOC_DRAFTER_DOCUMENT_INTERVIEW)

const DocumentListing = ({ title, isLast, description, uuid, hasAccess }) => {
  const dispatch = useDispatch()

  const isIE = useSelector(selectIsIE)
  const aol = useSelector(selectAolName)
  const isLogged = useSelector(selectIsLogged)

  const checkedDescription = description?.replace(/(<([^>]+)>)/ig, '').length ? description : null
  const route = SsoRoute.reverse({ uuid, aol })

  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (!isLogged) {
      dispatch(setSignUpModalIsOpen(true))
      e.preventDefault()
      e.stopPropagation()
    } else if (!hasAccess) {
      dispatch(setUserRolesModalIsBasicMessage(true))
      dispatch(setUserRolesModalIsOpen(true))
      e.preventDefault()
      e.stopPropagation()
    }
  }

  return (
    <li
      className={cx('min-h-spacing-9 bg-white', { 'bb b--precedents-blue': !isLast })}
    >
      <div className='relative'>
        <div className='pa6 pb5'>
          <div className='flex flex-wrap-reverse justify-between'>
            <div className='flex items-center'>
              <div className='flt-l mr6 h-100'>
                <Icon className='w6 vm' name='icon-file-document' />
              </div>
              <span className='b'> {title} </span>
            </div>
            <div className={cx({ 'items-center-ie-fix': isIE })}>
              <TealToolTip title='Start'>
                <a
                  className='pointer mh2 bg-inherit'
                  href={route}
                  onClick={handleOnClick}
                  data-help-item='automatedprecedentopen'
                  data-help-position='left'
                  data-event-category='Automated Precedents'
                  data-event-action='Open'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon className='w6 black' name='icon-play' />
                </a>
              </TealToolTip>
            </div>
          </div>
          <div className='precedents-description normal ml8' dangerouslySetInnerHTML={{ __html: checkedDescription }} />
        </div>
      </div>
    </li>
  )
}

export default DocumentListing
